import type { FC } from 'react';
import { Suspense, useCallback, useMemo } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Input } from '../Input';
import * as Styled from './styled';
import type { InputDateProps } from './types';

import 'react-calendar/dist/Calendar.css';

export * from './types';

export const InputDate: FC<InputDateProps> = (props) => {
  const { calendarProps, disabled = false, ...rest } = props;
  const uniqueId = useMemo(() => `input-date-${Math.random().toString(36).substr(2, 5)}`, []);

  const focusHackHandler = useCallback(() => {
    setTimeout(() => {
      document.getElementById(uniqueId)?.parentElement?.focus();
    }, 1);
  }, [uniqueId]);

  const focusBlurHandler = useCallback(() => {
    if (document.activeElement) {
      (document.activeElement as any).blur();
    }
  }, []);

  return (
    <Input
      {...rest}
      disabled={disabled}
      id={uniqueId}
      textDisabled
      dropdown={
        disabled ? undefined : (
          <Styled.Calendar
            prevLabel={<FaChevronLeft />}
            nextLabel={<FaChevronRight />}
            {...calendarProps}
            onClickMonth={(...params) => {
              calendarProps?.onClickMonth?.(...params);
              if (calendarProps?.maxDetail === 'year') {
                focusBlurHandler();
              } else {
                focusHackHandler();
              }
            }}
            onClickYear={(...params) => {
              calendarProps?.onClickYear?.(...params);
              focusHackHandler();
            }}
            onClickWeekNumber={(...params) => {
              calendarProps?.onClickWeekNumber?.(...params);
              focusHackHandler();
            }}
            onClickDecade={(...params) => {
              calendarProps?.onClickDecade?.(...params);
              focusHackHandler();
            }}
            onClickDay={(...params) => {
              calendarProps?.onClickDay?.(...params);
              focusBlurHandler();
            }}
          />
        )
      }
    />
  );
};
